import { CheckCircle, XCircle, Clock, Package } from 'lucide-react';

export function StatusCards({ filter, setFilter, counts }) {
  const stats = [
    { key: 'pending', label: 'Ventande', icon: Clock, c: 'text-amber-600 bg-amber-50 border-amber-200' },
    { key: 'approved', label: 'Godkjente', icon: CheckCircle, c: 'text-emerald-600 bg-emerald-50 border-emerald-200' },
    { key: 'completed', label: 'Fullførte', icon: Package, c: 'text-blue-600 bg-blue-50 border-blue-200' },
    { key: 'rejected', label: 'Avslåtte', icon: XCircle, c: 'text-red-600 bg-red-50 border-red-200' },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
      {stats.map(({ key, label, icon: Icon, c }) => (
        <button
          key={key}
          onClick={() => setFilter(filter === key ? 'all' : key)}
          data-testid={`status-card-${key}`}
          className={`p-3.5 rounded-xl border transition-all text-left ${
            filter === key ? c : 'bg-white border-slate-200 hover:border-slate-300'
          }`}
        >
          <div className="flex items-center justify-between mb-1">
            <span className={`text-xs font-medium ${filter === key ? '' : 'text-slate-500'}`}>{label}</span>
            <Icon className={`w-4 h-4 ${filter === key ? '' : 'text-slate-300'}`} />
          </div>
          <span className={`text-xl font-bold ${filter === key ? '' : 'text-slate-900'}`}>{counts[key]}</span>
        </button>
      ))}
    </div>
  );
}
